import { basicUIPlugin } from '@stackflow/plugin-basic-ui'
import { basicRendererPlugin } from '@stackflow/plugin-renderer-basic'
import { stackflow } from '@stackflow/react'
import { GetServerSideProps } from 'next'
import { useEffect, useMemo } from 'react'
import HelpCenterActivity from '../../../../components/webview/help-center/HelpCenterActivity'
import HelpCenterDetailActivity from '../../../../components/webview/help-center/HelpCenterDetailActivity'

const activities = {
  HelpCenterActivity,
  HelpCenterDetailActivity,
}

export type HelpCenterActivityNamesType = keyof typeof activities

export const useHelpCenterStack = (initialActivityName?: string | string[], initialParams?) => {
  const {
    Stack: HelpCenterStack,
    useFlow: useHelpCenterFlow,
    activities: HelpCenterActivities,
  } = useMemo(() => {
    return stackflow({
      transitionDuration: 350,
      activities: activities,
      plugins: [
        basicRendererPlugin(),
        basicUIPlugin({
          theme: 'cupertino',
        }),
        () => {
          return {
            key: 'HelpCenter-param-nested-navigation-plugin',
            overrideInitialEvents: ({ initialEvents }) => {
              const temp = {
                ...initialEvents[0],
                activityName: initialActivityName as HelpCenterActivityNamesType,
                activityParams: initialParams,
              }
              return [temp]
            },
          }
        },
      ],
      initialActivity: () => initialActivityName as HelpCenterActivityNamesType,
    })
  }, [initialActivityName])

  return { HelpCenterStack, HelpCenterActivities, useHelpCenterFlow }
}

const Index = ({ activity, slug }) => {
  const { HelpCenterStack, HelpCenterActivities } = useHelpCenterStack(activity, { slug: slug })

  useEffect(() => {
    setTimeout(() => {
      window.ChannelIO?.('showChannelButton')
    }, 100)
  }, [])
  return (
    <div className="h-full w-full ">
      <HelpCenterStack />
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (props) => {
  const { query } = props
  const { activity = 'HelpCenterActivity', slug = '' } = query
  return {
    props: {
      activity: activity,
      slug: slug,
    },
  }
}

export default Index
